export const SELECT_TOUR_HOME = 'SELECT_TOUR_HOME';
export const SELECT_TOUR_NATIONS = 'SELECT_TOUR_NATIONS';
export const SET_TOUR_NATION = 'SET_TOUR_NATION';
